module.exports = __webpack_public_path__ + "assets/52259bff8f934bfa311c185ca5c36d44.png";